import React, { createContext, useState } from 'react';

import OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData from './OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData';

export const OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionStateContext = createContext();

const OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionContextProvider = ({ children }) => {
  const stateHook = useState(OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData.INITIAL_STATE);

  return (
    <OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionStateContext.Provider value={stateHook}>
      {children}
    </OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionStateContext.Provider>
  );
};

export default OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionContextProvider;